window.addEventListener('DOMContentLoaded', function () {
  window.Medispa = window.Medispa || {};
  window.Medispa.carousels = window.Medispa.carousels || {};

  if (typeof Swiper !== 'undefined' && document.querySelector('.partner-logos-carousel')) {
    normalizePartnerSlides();

    window.Medispa.carousels['partners'] = new Swiper('.partner-logos-carousel', {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 24,
      slidesOffsetBefore: 40,
      slidesOffsetAfter: 40,
      navigation: {
        nextEl: '.partner-logos-carousel .swiper-button-next',
      },
      allowTouchMove: true,
      breakpoints: {
        768: {
          slidesOffsetBefore: 0
        },
        1139: {
          spaceBetween: 40,
        },
      },
    });
  }

  showStickyBookingNow();
  termsAndConditionsPopup();
});

function normalizePartnerSlides() {
  // When partner logos are nested theme blocks ({% content_for 'blocks' %}),
  // Shopify wraps each one in a .shopify-block div, but Swiper requires slides
  // to be direct children of .swiper-wrapper. Unwrap them before init. Skipped
  // in the theme editor, which needs the wrappers for block selection.
  if (window.Shopify && window.Shopify.designMode) return;

  document
    .querySelectorAll('.partner-logos-carousel .swiper-wrapper > .shopify-block')
    .forEach(function (wrapper) {
      var slide = wrapper.querySelector('.swiper-slide');

      if (slide) {
        wrapper.replaceWith(slide);
      } else {
        // Block rendered nothing (e.g. no logo selected) — drop the empty wrapper
        wrapper.remove();
      }
    });
}

function showStickyBookingNow() {
  var atcBtn = document.querySelector('.hero-banner-content-wrapper .booking-wrapper');
  var stickyBookings = document.querySelectorAll('.sticky-booking');

  if (!atcBtn || stickyBookings.length === 0) return;

  var isMobile = window.innerWidth < 768;

  // Additional offset to use for edges of screen to determine visibility
  var screenGutter = 20;

  // True once the viewport has reached the bottom of the document, so the bar
  // stops covering the last of the content when there is no scroll left to
  // reveal it. The threshold frees exactly the strip the bar would obscure.
  // Pages that don't scroll past that strip are exempt, otherwise the bar would
  // be hidden permanently.
  function atPageBottom() {
    var doc = document.documentElement;
    var barHeight = stickyBookings[0].offsetHeight || 48;
    var threshold = barHeight + screenGutter;

    if (doc.scrollHeight <= window.innerHeight + threshold) return false;

    return window.scrollY + window.innerHeight >= doc.scrollHeight - threshold;
  }

  function updateStickyVisibility() {
    var atcTop = atcBtn.getBoundingClientRect().top;
    var atcOffScreen = atcTop <= 0;
    var atcOnScreen = atcTop <= window.innerHeight - screenGutter && atcTop > screenGutter;

    var shouldHideSubnav =
      (!isMobile && !atcOffScreen) || (isMobile && atcOnScreen) || atPageBottom();

    stickyBookings.forEach(function (el) {
      el.classList.toggle('hide', shouldHideSubnav);
    });
  }

  window.addEventListener('resize', function () {
    isMobile = window.innerWidth < 768;
    updateStickyVisibility();
  });

  window.addEventListener('scroll', updateStickyVisibility, { passive: true });

  // Start with sticky ATC visible on mobile
  if (isMobile) {
    stickyBookings.forEach(function (el) {
      el.classList.remove('hide');
    });

    document.querySelectorAll('.sticky-booking .overlay').forEach(function (overlay) {
      overlay.addEventListener('click', function () {
        document
          .querySelectorAll('.sticky-booking .booking-wrapper, .sticky-booking .medispa-dropdown-trigger')
          .forEach(function (el) {
            el.classList.remove('open');
          });
      });
    });
  }
}

function termsAndConditionsPopup() {
  const popup = document.querySelector('.terms-and-conditions__popup-overlay');
  if (!popup) return;

  const popupButtons = document.querySelectorAll('.hero-terms-and-conditions__popup-button');

  popupButtons.forEach((el) => {
    el.addEventListener('click', () => {
      popup.classList.add('active');
      document.querySelector('html').style.overflowY = 'clip';
    });
  });

  const closePopup = () => {
    popup.classList.remove('active');
    document.querySelector('html').style.overflowY = 'auto';
  };

  const popupCloseButton = document.querySelector('.terms-and-conditions__close-popup');

  if (popupCloseButton) {
    popupCloseButton.addEventListener('click', closePopup);
  }

  popup.addEventListener('click', closePopup);
}
